import { render } from "./Work.vue?vue&type=template&id=6e3b2758&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=6e3b2758&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e3b2758"

export default script